import React, { Component } from 'react';
import Layout from '../components/layout';
import Logo from '../components/logo';
import Footer from '../components/footer';
import LocalStorageService from '../services/local-storage.service';
import { userService } from '../services';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

class RegisterForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        name: '',
        lastname: '',
        email: '',
      },
      acceptTerms: false,
      errors: {},
      sending: false,
    }
  }

  changeHandler = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    let user = this.state.user;
    let errors = this.state.errors;
    user[name] = value;
    errors[name] = '';

    this.setState({ user, errors });
  }

  checkTermsHandler = (event) => {
    let errors = this.state.errors;
    let checked = event.target.checked;
    errors.acceptTerms = '';

    this.setState({
      acceptTerms: checked,
      errors
    });
  }

  onSubmit = () => {
    const { user, acceptTerms } = this.state;
    let errors = { acceptTerms: '' };
    let isValid = true;

    if (!this._validEmail(user.email)) {
      errors.email = "Debe ingresar un correo válido";
      isValid = false;
    }

    if (!user.name) {
      errors.name = "El campo es obligatorio";
      isValid = false;
    }

    if (!user.lastname) {
      errors.lastname = "El campo es obligatorio";
      isValid = false
    }

    if (!acceptTerms) {
      errors.acceptTerms = "Para continnuar debe aceptar Términos y condiciones"
      isValid = false
    }

    if (isValid) {
      this.setState({ sending: true });
      this.sendRegister(user);
    } else {
      this.setState({
        errors,
        validForm: isValid
      });
    }

  }

  _validEmail = (email) => {
    let emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
    return emailRegex.test(email);
  }

  sendRegister = async (user) => {
    try {
      const response = await userService.register(user);
      LocalStorageService.set('session', response.data);
      this.props.registerCompleted();
    } catch (error) {
      this.onError();
    }
  }

  onError = () => {
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      text: 'Hubo un error al realizar su registro. Por favor, vuelva a intentarlo más tarde.',
      icon: 'error',
      buttonsStyling: false,
    })
  }

  _renderActions = () => {
    if (this.state.sending) {
      return (<div className="loader" style={{fontSize: '5px'}}></div>);
    } else {
      return (
        <button 
          type="button" 
          className="btn btn-primary"
          onClick={this.onSubmit}
        >
          Iniciar Demo
        </button>
      );
    }
  }

  render() {
    return (
      <Layout>
        <div className="register-form">
          <div className="container">
            <div className="header">
              <Logo campaign={ this.props.campaign.name || '' } />
            </div>
            <div className="row justify-content-md-center">
              <div className="col-12 col-md-5">
                <div className="text-message">
                  <h3>¡Hola!</h3>
                  {this.props.campaign && <p>{this.props.campaign.description}</p> }
                </div>
                <div className="form-wrap">
                  <p>
                    <strong>Ingresa los siguientes datos para comenzar</strong>
                  </p>
                  <form>
                    <div className="form-group">
                      <label>¿Con qué nombre quieres aparecer en la tabla de posiciones?</label>
                      <input 
                        type="text" 
                        name="name" 
                        className="form-control" 
                        value={this.state.user.name || ''}
                        onChange={this.changeHandler}
                      />
                      <span className="text-danger">
                        { this.state.errors && this.state.errors.name ? this.state.errors.name : '' }
                      </span>
                    </div>
                    <div className="form-group">
                      <label>Apellido paterno</label>
                      <input 
                        type="text" 
                        name="lastname" 
                        className="form-control" 
                        value={this.state.user.lastname}
                        onChange={this.changeHandler}
                      />
                      <span className="text-danger">
                        { this.state.errors && this.state.errors.lastname ? this.state.errors.lastname : '' }
                      </span>
                    </div>
                    <div className="form-group">
                      <label>¿A qué correo electrónico mandaremos tus resultados?</label>
                      <input 
                        type="email" 
                        name="email" 
                        className="form-control" 
                        value={this.state.user.email}
                        onChange={this.changeHandler}
                      />
                      <span className="text-danger">
                        { this.state.errors && this.state.errors.email ? this.state.errors.email : '' }
                      </span>
                    </div>
                    <div className="form-check">
                      <input 
                        className="form-check-input" 
                        type="checkbox" 
                        value="checked"
                        name="aceptaTerminos"
                        checked={this.state.acceptTerms}
                        id="termsCheck" 
                        onChange={this.checkTermsHandler}
                      />
                      <label className="form-check-label" htmlFor="termsCheck">
                        He leído y acepto los <a className="link-white" href="https://gameif.media/aviso_privacidad.html" target="_blank">Términos y Condiciones</a> de uso y el <a className="link-white" href="https://gameif.media/aviso_privacidad.html" target="_blank">Aviso de Privacidad</a>.
                      </label>
                    </div>
                    <div>
                      <span className="text-danger">
                        { this.state.errors && this.state.errors.acceptTerms ? this.state.errors.acceptTerms : '' }
                      </span>
                    </div>
                    <div className="form-actions">
                      { this._renderActions() }
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="footer-box">
              <Footer />
            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

export default RegisterForm;